import { escapeHtml } from "./utils";

/**
 * Kucuk, bagimliliksiz markdown → guvenli HTML donusturucu.
 *
 * AiNote yalniz IMGA'nin uretmis oldugu kisa AI notlarini gosterir (kalin,
 * madde isaretleri, paragraflar) — tam bir markdown motoru gerekmiyor.
 * Girdi ONCE tumuyle escape edilir, bicimlendirme yalniz onceden bilinen
 * guvenli etiketlere (`<strong>`, `<em>`, `<ul><li>`, `<p>`, `<br>`) donusur;
 * bu yuzden ciktida asla ham `<script>` vb. HTML enjekte edilemez.
 */
export function markdownToSafeHtml(source: string | null | undefined): string {
  if (!source) return "";

  const escaped = escapeHtml(source).replace(/\r\n/g, "\n");
  const blocks = escaped.split(/\n{2,}/).map((b) => b.trim()).filter(Boolean);

  const html = blocks
    .map((block) => {
      const lines = block.split("\n").map((l) => l.trim()).filter(Boolean);
      if (lines.length === 0) return "";

      // `#`/`##`/`###` basligi — yalniz blogun ILK satiri (gorev: AI notundaki
      // "### Gidişat" gibi basliklar ham metin degil h3/h4 olarak cizilsin).
      const baslikEslesme = /^(#{1,3})\s+(.+)$/.exec(lines[0]);
      if (baslikEslesme) {
        const seviye = baslikEslesme[1].length;
        const etiket = seviye >= 3 ? "h4" : "h3";
        const cls = etiket === "h4" ? "mt-3 text-sm font-semibold text-ink" : "mt-3 text-base font-semibold text-ink";
        const baslikHtml = `<${etiket} class="${cls}">${inline(baslikEslesme[2])}</${etiket}>`;
        const kalan = lines.slice(1);
        if (kalan.length === 0) return baslikHtml;
        const kalanListeMi = kalan.every((l) => /^[-*]\s+/.test(l));
        if (kalanListeMi) {
          const items = kalan.map((l) => `<li>${inline(l.replace(/^[-*]\s+/, ""))}</li>`).join("");
          return `${baslikHtml}<ul>${items}</ul>`;
        }
        return `${baslikHtml}<p>${kalan.map(inline).join("<br />")}</p>`;
      }

      const isList = lines.length > 0 && lines.every((l) => /^[-*]\s+/.test(l));
      if (isList) {
        const items = lines.map((l) => `<li>${inline(l.replace(/^[-*]\s+/, ""))}</li>`).join("");
        return `<ul>${items}</ul>`;
      }
      return `<p>${lines.map(inline).join("<br />")}</p>`;
    })
    .join("");

  return html;
}

function inline(text: string): string {
  return text
    .replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>")
    .replace(/(?<!\*)\*(?!\*)(.+?)\*(?!\*)/g, "<em>$1</em>")
    .replace(/_(.+?)_/g, "<em>$1</em>");
}
